import { TableComment } from "../TableComment";
import { Button, DataSource, Label, Layout, Panel, Switch, Tab, Tabset, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutContact extends Layout {
    buttonViewUser: Button;
    labelR: Label;
    layoutComments: TableComment;
    panelRecurringContact: Panel;
    sourceComments: DataSource;
    sourceContacts: DataSource;
    switchDetentionContact: Switch;
    switchIsActive: Switch;
    switchPayableContact: Switch;
    switchPrimaryContact: Switch;
    switchSMSOptIn: Switch;
    panelPortalUser: Panel;
    switchWebAccess: Switch;
    tabComments: Tab;
    tabContactData: Tab;
    tabsetContact: Tabset;
    textboxEmail: Textbox;
    textboxLoginId: Textbox;
    textboxMobilePhone: Textbox;
    textboxName: Textbox;
    textboxOptOutDate: Textbox;
    textboxPhone: Textbox;
    textboxRapidAlertNotify: Textbox;
    textboxRecInterval: Textbox;
    textboxRecNextDate: Textbox;
    textboxRecOpsUserId: Textbox;
    textboxRecSalespersonId: Textbox;
    textboxTitle: Textbox;
    textboxTypeOf: Textbox;
    textboxUserId: Textbox;
    textboxVerifiedDate: Textbox;
    textboxVerifiedStatus: Textbox;
    textboxWebPassword: Textbox;
    textboxWebUserId: Textbox;
}
